import React from 'react';

// Placeholder learning hub. The real build hosts indicator walkthroughs and
// market-education lessons (the core "we are educators" value).
const LearnPage: React.FC = () => {
  return (
    <>
      <section className="page-head">
        <h1>Learn</h1>
        <p className="page-sub">Indicator walkthroughs &amp; market lessons — coming soon.</p>
      </section>

      <div className="stub-panel">
        <p>
          Lessons will connect each CCFOS indicator to the chart and the reasoning
          behind it, so you can learn to read markets yourself. Purely educational —
          no advice, no signals to act on.
        </p>
      </div>
    </>
  );
};

export default LearnPage;
